import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeLanguageOnStartupComponent } from './change-language/change-language.component';
import { StartUpComponent } from './start-up.component';
import { LanguageTemplateComponent } from '../setting/change-language/template/language-template/language-template.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    ChangeLanguageOnStartupComponent,
    StartUpComponent,
    LanguageTemplateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    TranslocoModule
  ],
  exports: [
    SharedModule,
    TranslocoModule,
    LanguageTemplateComponent
  ]
})
export class StartUpModule { }
